<template>
  <div class="report-view">
    <div class="table">
  
      <fieldset class="vita-form-fieldset">
        <legend>培训班整体情况</legend>
        <p>培训班整体情况：{{report.tissue_situation || "--"}}</p>
      </fieldset>
  
  
      <fieldset class="vita-form-fieldset">
        <legend>学员情况</legend>
        <p v-if="report.student_situation_socre">学员整体是否达到参加该级别培训的水准：{{report.student_situation_socre || "--"}} 分</p>
        <p>学员整体情况描述：{{report.student_situation || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset">
        <legend>场地设施器材情况</legend>
        <p v-if="report.theory_room_score">对理论课教室的满意度：{{report.theory_room_score || "--"}} 分</p>
        <p v-if="report.practice_room_score">对实践课场地的满意度：{{report.practice_room_score || "--"}} 分</p>
        <p>情况反馈：{{report.facility_situation || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset">
        <legend>器材情况</legend>
        <p v-if="report.equipment_score">对相关器材满意度：{{report.equipment_score || "--"}} 分</p>
        <p v-if="report.equipment_student_score">对学员装备配置的满意度：{{report.equipment_student_score || "--"}} 分</p>
        <p>情况反馈：{{report.equipment_situation || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset">
        <legend>食宿情况</legend>
        <p v-if="report.eat_score">对培训期间餐饮条件满意度：{{report.eat_score || "--"}} 分</p>
        <p v-if="report.sleep_score">对培训期间住宿条件满意度：{{report.sleep_score || "--"}} 分</p>
        <p>情况反馈：{{report.eating_situation || "--"}}</p>
      </fieldset>
      
      <fieldset class="vita-form-fieldset">
        <legend>交通情况</legend>
        <p v-if="report.eat_score">培训期间是否需要用车往返培训场地：{{report.is_use_car == '1' ?'是':'否'}}</p>
        <p>培训地的交通情况：{{report.traffic_situation || "--"}}</p>
      </fieldset>
      
      <fieldset class="vita-form-fieldset" v-if="isHighClass && report.practice_team_eva_score && ['train','physical_train','goalkeeper_train'].includes(classTrainType)">
        <legend>实践队情况</legend>
        <p>对培训实践队的整体满意度：{{report.practice_team_eva_score || '--'}} 分</p>
        <p>情况反馈：{{report.practice_team_eva || "--"}}</p>
      </fieldset>
      
      <fieldset class="vita-form-fieldset" v-if="report.myself_eva_score && ['train','physical_train','goalkeeper_train'].includes(classTrainType)">
        <legend>自我评价</legend>
        <p>对自我表现的满意度：{{report.myself_eva_score || '--'}} 分</p>
        <p>情况反馈：{{report.myself_eva || "--"}}</p>
      </fieldset>
      
      <fieldset class="vita-form-fieldset" v-if="['train','physical_train','goalkeeper_train'].includes(classTrainType)">
        <legend>对助理讲师的评价</legend>
        <p>反馈及建议：{{report.assistant_teacher_evaluate || "--"}}</p>
      </fieldset>

      <fieldset class="vita-form-fieldset" v-if="report.teacher_zhuli_evaluate">
        <legend>对讲师助理的评价</legend>
        <p>反馈及建议：{{report.teacher_zhuli_evaluate || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset" v-if="isHighClass && report.goalkeeper_teacher_eva_score && ['train'].includes(classTrainType)">
        <legend>对守门员专项讲师的评价</legend>
        <p>对守门员专项讲师的整体满意度：{{report.goalkeeper_teacher_eva_score || '--'}} 分</p>
        <p>反馈及建议：{{report.goalkeeper_teacher_eva || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset" v-if="isHighClass && report.physical_teacher_eva_score && ['train'].includes(classTrainType)">
        <legend>对体能专项讲师的评价</legend>
        <p>对体能专项讲师的整体满意度：{{report.physical_teacher_eva_score || '--'}} 分</p>
        <p>反馈及建议：{{report.physical_teacher_eva || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset" v-if="isHighClass && report.other_teacher_eva && ['train','physical_train','goalkeeper_train'].includes(classTrainType)">
        <legend>对其他专项、专题讲师的评价</legend>
        <p>对其他专项、专题讲师的评价：{{report.other_teacher_eva || "--"}}</p>
      </fieldset>
      
      <fieldset class="vita-form-fieldset" v-if="report.link_man_eva_score && ['train','physical_train','goalkeeper_train'].includes(classTrainType)">
        <legend>对协调员评价</legend>
        <p>对协调员的整体满意度：{{report.link_man_eva_score || '--'}} 分</p>
        <p>反馈及建议：{{report.link_man_eva || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset" v-if="report.organ_eva_score && ['train','physical_train','goalkeeper_train'].includes(classTrainType)">
        <legend>{{isHighClass ? "对培训承办机构的评价":"对培训主办机构的评价"}}</legend>
        <p>{{isHighClass ? "对培训承办机构的整体满意度":"对培训主办机构的整体满意度"}}：{{report.organ_eva_score || '--'}} 分</p>
        <p>反馈及建议：{{report.organ_eva || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset" v-if="['train','physical_train','goalkeeper_train'].includes(classTrainType)">
        <legend>对未来培训工作的建议</legend>
        <p>对未来培训工作的建议：{{report.class_suggest || "--"}}</p>
      </fieldset>
  
      <fieldset class="vita-form-fieldset">
        <legend>其他意见及建议</legend>
        <p>其他意见及建议：{{report.remark || "--"}}</p>
      </fieldset>
      
    </div>
  </div>
</template>

<script>
  export default {
    name: "class-report",
    props: {
      report: {
        type: Object,
        required: true,
      },
      isHighClass:{
        type:Boolean,
        required:true,
      },
      classTrainType:{
        type:String,
        required:true,
      }
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .report-view {
    .table {
      border: 1px solid $color_white;
      .vita-form-fieldset {
        margin: 15px;
        padding: 10px;
        border: 1px solid $color_white;
        position :relative
        font-size:$font_size_medium
      }
      
      
      .report-row {
        font-size: $font_size_medium;
        border-bottom: 1px solid $color_white;
        &:last-child {
          border-bottom: none;
        }
        .report-col {
          padding: 10px;
          word-break: break-all;
          /*&:first-child {
            text-align: right;
          }*/
          &:first-child {
            border-right: 1px solid $color_white;
          }
        }
        .no-border{
          border:none !important;
        }
      }
    }
  }
</style>
